import Plugin from '../core/Plugin';
import * as SelectionUtils from '../SelectionUtils';

/**
 * TextFormattingPlugin - Handles bold, italic, underline, strikethrough
 */
class TextFormattingPlugin extends Plugin {
  constructor(editor, options = {}) {
    super(editor, options);
    this.name = 'TextFormatting';
  }

  getToolbarButtons() {
    return [
      {
        name: 'text-style',
        buttons: [
          { command: 'bold', label: '<b>B</b>', title: 'Bold' },
          { command: 'italic', label: '<i>I</i>', title: 'Italic' },
          { command: 'underline', label: '<u>U</u>', title: 'Underline' },
          { command: 'strikethrough', label: '<s>S</s>', title: 'Strikethrough' },
        ],
      },
      {
        name: 'font-color',
        dropdown: {
          command: 'font-color',
          label: 'Font Color',
          title: 'Select Font Color',
          options: [
            { value: 'black', label: 'Black' },
            { value: 'white', label: 'White' },
            { value: 'gray', label: 'Gray' },
            { value: 'silver', label: 'Silver' },
            { value: 'red', label: 'Red' },
            { value: 'orange', label: 'Orange' },
            { value: 'yellow', label: 'Yellow' },
            { value: 'green', label: 'Green' },
            { value: 'teal', label: 'Teal' },
            { value: 'blue', label: 'Blue' },
            { value: 'navy', label: 'Navy' },
            { value: 'purple', label: 'Purple' },
            { value: 'pink', label: 'Pink' },
            { value: 'brown', label: 'Brown' },
          ],
        },
      },
    ];
  }

  executeCommand(command) {
    switch (command) {
      case 'bold':
        SelectionUtils.wrapSelection('b');
        break;
      case 'italic':
        SelectionUtils.wrapSelection('i');
        break;
      case 'underline':
        SelectionUtils.wrapSelection('u');
        break;
      case 'strikethrough':
        SelectionUtils.wrapSelection('s');
        break;
      case 'font-color-black':
      case 'font-color-white':
      case 'font-color-gray':
      case 'font-color-silver':
      case 'font-color-red':
      case 'font-color-orange':
      case 'font-color-yellow':
      case 'font-color-green':
      case 'font-color-teal':
      case 'font-color-blue':
      case 'font-color-navy':
      case 'font-color-purple':
      case 'font-color-pink':
      case 'font-color-brown': {
        const color = command.replace('font-color-', '');
        SelectionUtils.wrapSelection('span', { style: `color: ${color};` });
        break;
      }
    }
  }

  getMetadata() {
    return {
      name: 'Text Formatting',
      version: '1.2.0',
      description: 'Provides bold, italic, underline, strikethrough, and font color formatting',
      author: 'AtlaraFirm',
    };
  }
}
export default TextFormattingPlugin;
